import * as React from 'react';
import { useSelector } from 'react-redux';
import { useDynamicBoolean } from '@doordash/component-dynamic-values';
import { getSelectedTeamAccountContent } from '../selectors/uiSelector';
import { getTeamId, getIsAdmin, getTeamName, getCurrentTeamMember, } from '../selectors/portal_selector';
import { DYNAMIC_VALUES_NAME } from './DynamicValues';
import PendoUtil from '../bootstrap/pendo';
import { useTeamAccountConfigurationContext } from './TeamAccountPlanDetails/TeamAccountConfigurationContext';
import { useGetConsumerInfo } from './DynamicValues/hook';
export var PendoContainer = function () {
    var consumerId = useGetConsumerInfo().consumerId;
    var teamId = useSelector(getTeamId) || '';
    var teamName = useSelector(getTeamName) || '';
    var isAdmin = useSelector(getIsAdmin);
    var selectedTeamAccountContent = useSelector(getSelectedTeamAccountContent);
    var currentTeamMember = useSelector(getCurrentTeamMember);
    var teamAccountPlan = useTeamAccountConfigurationContext().teamAccountPlan;
    var isPendoEnabled = useDynamicBoolean(DYNAMIC_VALUES_NAME.ddfwPendoEnabled, {
        consumerId: consumerId,
        teamId: teamId,
    });
    var initializePendo = React.useCallback(function () {
        if (isPendoEnabled &&
            isAdmin &&
            selectedTeamAccountContent &&
            teamAccountPlan) {
            PendoUtil.initializePendo(consumerId, currentTeamMember, selectedTeamAccountContent, teamId, teamName, teamAccountPlan);
        }
    }, [
        selectedTeamAccountContent,
        consumerId,
        teamId,
        teamName,
        isAdmin,
        isPendoEnabled,
        currentTeamMember,
        teamAccountPlan,
    ]);
    React.useEffect(function () {
        initializePendo();
    }, [initializePendo]);
    return null;
};
export default PendoContainer;
